import React from 'react';
import PropTypes from 'prop-types';
import * as Sentry from '@sentry/react';
import isValidException from 'utils/isValidException';

import {withI18n} from 'spa/Components/Context';
import {withRouter, routerShape, locationShape} from 'react-router';
import { runInAction } from 'mobx';
import { inject } from 'mobx-react';
import Dialog, { DialogStatus } from '@urbanmassage/component-library/lib/Dialog/Dialog';
import AddressSelector from '../AddressSelector/AddressSelector';
import AddressNotServiced from '../AddressSelector/AddressNotServiced';
import { BOOKING_BASE_URL } from '../../../utils/constants';

import './address-modal.less';

const AddressModal = ({
  basketNew,
  notifications,
  onUseAddress,
  location,
  router,
}, {i18n}) => {
  const [showAddressNotServiced, setShowAddressNotServiced] = React.useState(false);
  const [selectedAddressInfo, setSelectedAddressInfo] = React.useState(null);

  const onClearAddress = () => {};

  const onClickUseAddress = (addressInfo) => {
    const selectedAddress = {
      address_id: addressInfo.address_id,
      place_id: addressInfo.place_id,
      provider_id: addressInfo.provider_id,
    };
    setSelectedAddressInfo(selectedAddress);

    basketNew.basketsAppointmentsAddress.put('', selectedAddress)
      .then(() => {
        runInAction(() => {
          if (location.query.appointment_id) {
            router.push(`/${i18n.lc}/${BOOKING_BASE_URL}/basket`);
            return;
          }
          onUseAddress && onUseAddress();
        });
      }, (error) => {
        runInAction(() => {
          if (error.json && error.json.code === 'ADDRESS_NOT_SERVICED') {
            setShowAddressNotServiced(true);
          } else {
            if (__DEV__) {
              console.error(error);
            }
            notifications.add({
              id: 'addAddressBasketError',
              type: 'error',
              title: i18n.__error(error),
            });

            // This is unexpected so record it in Sentry
            if (isValidException(error)) {
              Sentry.captureException(error);
            } else {
              Sentry.captureMessage('Address screen unhandled error address to basket appointment');
            }
          }
        });
      }).catch((err) => {
        if (__DEV__) {
          console.error(err);
        }

        // This is unexpected so record it in Sentry
        if (isValidException(err)) {
          Sentry.captureException(err);
        } else {
          Sentry.captureMessage('Address screen unhandled error address to basket appointment');
        }
      });
  };

  const onClickNewSearch = () => {
    setShowAddressNotServiced(false);
  };

  return (
    <Dialog
      size="LARGE"
      preventClose
      rounded
      dialogStatus={DialogStatus.OPEN}
      onClose={() => false}
    >
      <div className="address-modal__selector-wrapper">
        {showAddressNotServiced ? (
          <AddressNotServiced
            onClickNewSearch={onClickNewSearch}
            search={selectedAddressInfo}
          />
        ) : (
          <AddressSelector onClearAddress={onClearAddress} onClickUseAddress={onClickUseAddress} visibleButton />
        )}
      </div>
    </Dialog>
  );
};

AddressModal.propTypes = {
  basketNew: PropTypes.shape({
    basketsAppointmentsAddress: PropTypes.object,
  }).isRequired,
  location: locationShape.isRequired,
  notifications: PropTypes.object,
  onUseAddress: PropTypes.func.isRequired,
  router: routerShape.isRequired,
};

export default withRouter(inject(({
  store: {
    basketNew,
    notifications,
  },
}) => ({
  basketNew,
  notifications,
}))(withI18n(AddressModal)));



// WEBPACK FOOTER //
// ./spa/Components/AddressModal/AddressModal.jsx